<template>
  <JurnalList jenisJurnal="8" :title="title"  :routeInput="input" :routeEdit="edit" />
</template>

<script>
import JurnalList from '@/views/jurnal/JurnalList.vue';

export default {
    components: {
        JurnalList
    },
    data:() => ({
       title : 'Jurnal Aktiva',
       input : 'jraktivainput',
       edit : 'jraktivaedit'
    }),
    methods: {
       
    }
}
</script>


<style>

</style>